import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatRadioChange } from '@angular/material/radio';
import { Question, QuestionAnswer } from 'src/app/interfaces/question';
import { QuestionAnswerOption } from './../../../../interfaces/question';

@Component({
  selector: 'question-select',
  template: `
    <div *ngIf="question" class="select-question-wrapper">
      <div class="radio-button-wrapper">
        <mat-radio-group (change)="onSelected($event)">
          <mat-radio-button *ngFor="let option of question.answerOptions; let idx = index" [value]="option" [checked]="checkedOption === idx">{{option.value}}</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
  `,
  styleUrls: ['../../../../../theme/radio-button.scss', './select-question.component.scss'],
})
export class SelectQuestionComponent implements OnInit {

  @Input() question: Question | undefined;
  @Input() checkedOption: number | undefined;
  @Output() answered = new EventEmitter<QuestionAnswer>();
  
  constructor() { }

  ngOnInit() {}

  onSelected($event: MatRadioChange): void {
    if (this.question === undefined) {
      return;
    }
    const selectedOption: QuestionAnswerOption = $event.value;
    this.answered.emit({
      ...selectedOption,
      options: [selectedOption.id],
      questionAnswerSet: [{
        question: this.question,
        metaRelations: []
      }]
    });
  }

}
